import { LayoutModule } from '@angular/cdk/layout';
import { OverlayModule } from '@angular/cdk/overlay';
import { NgModule, ErrorHandler, APP_INITIALIZER, InjectionToken } from '@angular/core';
// NGX Permissions
//import { NgxPermissionsModule } from 'ngx-permissions';
import { NgxPermissionsModule } from './shared/modules/ngx-permissions';

import { MatPaginatorIntl } from '@angular/material/paginator';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { AuthGuard, AuthGroupsGuard, CanDeactivateGuard, LayoutService, RequestService, StoreService, LoggerService, GlobalErrorHandler, RoomSessionService, LoaderService, UserDefaultsService, TokBoxService, PictureWallService, MatPaginationIntlService, FeaturesPermissionService, MessagesStatusService, LocalStorageService, RequestExternalService } from './shared';
import { LayoutUtilsService, MenuConfigService, SubheaderService, PageScopeService, UrlHelperService, UserActivityService, SchedulerService, rollbarFactory, RollbarService } from './shared/services';
//import { BdcWalkModule } from 'bdc-walkthrough';
import { CalendarModule } from './shared/modules/calendar';
import { BdcWalkModule } from './shared/modules/bdc-walkthrough';
import { SharedModule } from './shared/shared.module';
import { LayoutComponentModule } from './shared/layout.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CKEditorModule } from 'ngx-ckeditor';
import { ResizableModule } from './shared/directives/angular-resizable-element';
import { ImageCropperModule } from 'ngx-image-cropper';
import { EmptyComponent } from './empty/empty.component';
import { environment } from '../environments/environment';
import { MobileComponent } from './mobile/mobile.component';
import { RecorderService } from './shared/services/recorder.service';
import { ChartService } from './shared/services/chart.service';
import { AblyService } from './shared/services/ably.service';
import { ChatService } from './shared/services/chat.service';
import { KeyboardShortcutsModule } from 'ng-keyboard-shortcuts';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive'; // this includes the core NgIdleModule but includes keepalive providers for easy wireup
import { SpeedTestModule } from 'ng-speed-test';
import { SpeedCheckService } from './shared/services/networkspeed.service';
import { WindowRefService } from './shared/services/window-ref.service';
import { ServiceWorkerModule } from '@angular/service-worker';

// AoT requires an exported function for factories
export const createTranslateLoader = (http: HttpClient) => {
  return new TranslateHttpLoader(http, './assets/vertical/' + environment.orgSubType + '/i18n/', '.json');
};

@NgModule({
  declarations: [AppComponent, EmptyComponent, MobileComponent],
  imports: [
    BrowserModule,
    KeyboardShortcutsModule.forRoot(),
    AppRoutingModule,
    BrowserAnimationsModule,
    LayoutModule,
    SharedModule,
    LayoutComponentModule,
    OverlayModule,
    HttpClientModule,
    CKEditorModule,
    ResizableModule,
    BdcWalkModule,
    CalendarModule,
    ImageCropperModule,
    SpeedTestModule,
    NgIdleKeepaliveModule.forRoot(),
    NgxPermissionsModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      }
    }),
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: true,
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    })
  ],
  providers: [
    AuthGuard,
    CanDeactivateGuard,
    RequestService,
    RequestExternalService,
    LocalStorageService,
    FeaturesPermissionService,
    MessagesStatusService,
    RoomSessionService,
    PictureWallService,
    LayoutService,
    ChartService,
    TokBoxService,
    RecorderService,
    UserDefaultsService,
    LoaderService,
    AblyService,
    ChatService,
    StoreService,
    LayoutUtilsService,
    MenuConfigService,
    SubheaderService,
    PageScopeService,
    UrlHelperService,
    UserActivityService,
    SchedulerService,
    LoggerService,
    SpeedCheckService,
    WindowRefService,
    // {
    //   provide: ErrorHandler,
    //   useClass: GlobalErrorHandler
    // },
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    { provide: RollbarService, useFactory: rollbarFactory },
    {
      provide: MatPaginatorIntl,
      useClass: MatPaginationIntlService,
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
